define('SC.ThreadsThemeExtension.LogoView', [
	'sc-threads-logo.tpl',
	'Backbone','Utils',
	'SC.ThreadsThemeExtension.Common.Configuration'
], function (
	Template, 
	Backbone, 
	Utils, 
	Configuration
) {
	'use strict';
	return Backbone.View.extend({
		template: Template,
		getContext: function() {
			return {
				logoUrl: Utils.getAbsoluteUrlOfNonManagedResources(
					Configuration.get('header.logoUrl')
				),
				headerLinkHref: '/',
				headerLinkTouchPoint: 'home',
				headerLinkHashtag: '#',
				headerLinkTitle: Configuration.getSiteSettings().displayname
			}
		}
	})
})
